// extracted by mini-css-extract-plugin
export default {"header-item":"nzLp","header-items":"_xC5","primary-nav-link":"kmQA","primary-menu-item-content":"ebHU","active":"LoZc"};